import React, { useEffect } from 'react';
import { APITypes } from '../../../../../../../primary-record-types';
import { getIntl } from '../../../../../../../utils/intl';
import getDateString from '../../../../../../../utils/getDateString';
import Button from '../../../../../../v2BaseComponents/Button';
import { useIsFocused } from '@react-navigation/native';
import { SelectListPrompt } from '../../../../../../v2BaseComponents/Prompt';

const intl = getIntl('MobileChatList', {
    defaultTitle: 'Chat on {date}',
    previousChats: 'Previous',
});

export type MobileChatListOwnProps = {
    chats: APITypes.chatService.ListMedicalProfileChatsResponse;
    selectedChatId: string | null;
    onSelectChat: (chatId: string | null) => void;
    isDisabled: boolean;
};

export type MobileChatListProps = MobileChatListOwnProps;
const MobileChatList: React.FC<MobileChatListProps> = ({ chats, selectedChatId, onSelectChat, isDisabled }) => {
    const isFocused = useIsFocused();
    const [isChatListOpen, setIsChatListOpen] = React.useState(false);
    useEffect(() => {
        if (!isFocused) {
            setIsChatListOpen(false);
        }
    }, [isFocused]);

    if (!chats.items.length) {
        return null;
    }

    return (
        <>
            <Button
                variant="ghost"
                leftIcon="List"
                onPress={() => setIsChatListOpen(!isChatListOpen)}
                title={intl('previousChats')}
                testID="prompt-previous-chats"
                isDisabled={isDisabled}
            />
            <SelectListPrompt
                options={chats.items
                    .sort((a, b) => new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime())
                    .map((chat, index) => ({
                        label: chat.title
                            ? `${chat.title} (${getDateString(chat.createdDateTime, 'date')})`
                            : intl('defaultTitle', { date: getDateString(chat.createdDateTime, 'date') }),
                        value: chat.chatId,
                        testID: `chat-list-item-${index}`,
                    }))}
                value={selectedChatId}
                onChange={(value) => {
                    onSelectChat(value);
                    setIsChatListOpen(false);
                }}
                title={intl('previousChats')}
                isOpen={isChatListOpen}
                setIsOpen={(isOpen) => setIsChatListOpen(isOpen)}
            />
        </>
    );
};

export default React.memo(MobileChatList);
